import { Heading } from '@lmc/ui-kit'
import Divider from '@lmc/ui-kit/src/layout/Divider/Divider'
import styled from 'styled-components'

type IncidentCardProps = {
  children: React.ReactNode
  title: string | React.ReactNode
  subtitle?: string | React.ReactNode
  headerAction?: React.ReactNode
  divider?: boolean
  testId?: string
}

export const IncidentCard = ({
  children,
  title,
  subtitle,
  headerAction,
  divider,
  testId = 'incident-card'
}: IncidentCardProps) => {
  return (
    <CardContainer data-testid={testId}>
      <HeadingContainer data-testid={`${testId}-heading-container`}>
        <TitleContainer data-testid={`${testId}-title-container`}>
          <TitleText level={2} data-testid={`${testId}-title`}>
            {title}
          </TitleText>
          {headerAction && (
            <span data-testid={`${testId}-header-action`}>{headerAction}</span>
          )}
        </TitleContainer>
        {subtitle && (
          <SubtitleText level={5} data-testid={`${testId}-subtitle`}>
            {subtitle}
          </SubtitleText>
        )}
        {divider && <Divider data-testid={`${testId}-divider`} />}
      </HeadingContainer>
      <div data-testid={`${testId}-content`}>{children}</div>
    </CardContainer>
  )
}

const CardContainer = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.color.neutral.color11};
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  ${({ theme }) => theme.mediaQueries?.mobileDown} {
    width: auto;
  }
`
const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: ${(props) => props.theme.font.family.sansSerif};
`

const TitleText = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color3};
`

const SubtitleText = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color4};
  font-size: 16px;
`
